"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = useResizeObserver;
var _react = require("react");
/**
 * useResizeObserver
 *
 * @param ref - React ref to a DOM element
 * @param callback - Function called with ResizeObserverEntry[] when the element is resized
 */
function useResizeObserver(ref, callback) {
  (0, _react.useEffect)(function () {
    var node = ref.current;
    if (!node) {
      return;
    }
    var observer = new ResizeObserver(function (entries) {
      if (!document.body.contains(node)) {
        cleanup();
        return;
      }
      callback(entries);
    });
    function cleanup() {
      observer.disconnect();
    }
    observer.observe(node);
    return cleanup;
  }, [ref, callback]);
}
//# sourceMappingURL=useResizeObserver.js.map